import { render } from "./income.vue?vue&type=template&id=8771beee&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=8771beee&lang=scss&scoped=true"
import "./income.vue?vue&type=style&index=1&id=8771beee&lang=css"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8771beee"]])

export default __exports__